import React, { useState, useRef, useEffect } from 'react';
import './PromptInput.css';

const PromptInput = ({ onSubmit, isLoading = false, initialValue = '' }) => {
  const [prompt, setPrompt] = useState(initialValue);
  const textareaRef = useRef(null);

  useEffect(() => {
    if (initialValue) {
      setPrompt(initialValue);
    }
  }, [initialValue]);

  // Auto-grow textarea
  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = `${Math.min(textarea.scrollHeight, 200)}px`;
    }
  }, [prompt]);

  const handleChange = (e) => {
    const value = e.target.value;
    if (value.length <= 1000) {
      setPrompt(value);
    }
  };

  const handleKeyDown = (e) => {
    // Cmd+Enter or Ctrl+Enter to submit
    if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') {
      e.preventDefault();
      handleSubmit();
    }
    // Regular Enter creates a new line (default behavior)
  };

  const handleSubmit = () => {
    if (prompt.trim() && !isLoading && onSubmit) {
      onSubmit(prompt.trim());
    }
  };

  const handleButtonClick = (e) => {
    e.preventDefault();
    handleSubmit();
  };

  return (
    <div className="prompt-input">
      <h2 className="prompt-input__heading">What would you like to achieve?</h2>
      <p className="prompt-input__subheading">
        Tell us about your goals, what you would like to predict or anticipate and provide relevant business context.
      </p>
      
      <div className="prompt-input__wrapper">
        <textarea
          ref={textareaRef}
          className="prompt-input__textarea"
          value={prompt}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          placeholder="E.g., I want to predict customer churn for my subscription service..."
          maxLength={1000}
          disabled={isLoading}
        />
        
        <button
          className="prompt-input__submit-btn"
          onClick={handleButtonClick}
          disabled={!prompt.trim() || isLoading}
          aria-label="Submit prompt"
        >
          {isLoading ? (
            <div className="prompt-input__loading">
              <span className="prompt-input__dot"></span>
              <span className="prompt-input__dot"></span>
              <span className="prompt-input__dot"></span>
            </div>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-send" viewBox="0 0 16 16">
              <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576zm6.787-8.201L1.591 6.602l4.339 2.76z"/>
            </svg>
          )}
        </button>
      </div>
      
      <div className="prompt-input__footer">
        <span className="prompt-input__counter">
          {prompt.length}/1000 characters
        </span>
        <span className="prompt-input__hint">
          Press Cmd+Enter to submit
        </span>
      </div>
    </div>
  );
};

export default PromptInput;

